<!--
 * @Date: 2022-09-24 19:19:03
 * @LastEditTime: 2022-12-14 18:10:59
 * @Description: 青心计划 分享海报
-->
<template>
  <div class="bill-wrapper">
    <div
      v-if="!showBill"
      ref="credentialsShare"
      class="qingxin-disseminate-bill"
    >
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/10/08/a494/7de7393dfc74_w1125_h747_.png"
        alt=""
        class="bg"
      />
      <div class="card-wrapper">
        <img
          src="https://staff.chunyu.mobi/@/media/images/2022/09/28/d5ff/cdab14f6ca49_w264_h288_.png"
          alt=""
          class="little-pi"
        />
        <div class="img-wrapper">
          <img :src="imageSrc[0]" alt="" class="img" />
        </div>
        <div class="text-wrapper">
          <div
            v-if="!billCreating"
            class="change-button"
            @click="randomGetText"
          >
            <span class="tips">
              点击下方文字可修改，或点我换一换
            </span>
            <img
              src="data:image/png;base64,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"
              alt=""
              class="change-button-icon"
            />
          </div>
          <div class="text" @click="onEditClick">
            {{ showText }}
          </div>
          <img :src="tagImage" alt="" class="tag-image" />
        </div>
        <div class="split" />
        <div class="bottom-info">
          <div class="qingxin-text">
            <span>我是 {{ data.nickname }}</span>
            <span> 第{{ data.attend_num }}位青心计划代言人 </span>
            <span>
              和我一起传递温暖吧~
            </span>
            <div class="tip-wrapper">
              长按或扫码参与活动
              <img
                src="data:image/png;base64,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"
                alt=""
                class="tip-icon"
              />
            </div>
          </div>
          <div class="qr-wrapper">
            <img :src="data.qr_code" alt="" class="qr" />
          </div>
        </div>
      </div>
      <div v-if="showEdit" class="edit-wrapper">
        <div class="text-area-wrapper">
          <cube-textarea
            v-model="inputText"
            class="text-area"
            :autofocus="true"
            :maxlength="32"
            placeholder=""
          />
        </div>
        <div class="submit-button-wrapper">
          <div class="button" @click="submitText">确认</div>
        </div>
      </div>
      <img
        src="https://staff.chunyu.mobi/@/media/images/2022/09/28/9dd8/0a1a6350abcc_w738_h60_.png"
        alt=""
        class="bottom-img"
      />
    </div>
    <div class="bottom-button">
      <UploadImg
        v-model="imageSrc"
        :visible.sync="isShowH5UploadLoading"
        :multiple="false"
        :upload-config="uploadConfig"
        class="upload-button"
        origin="reupload-button"
      >
        <template>
          <div class="left">重新选择</div>
        </template>
      </UploadImg>
      <div class="right" @click="getBill">生成海报分享好友</div>
    </div>
    <div v-show="showBill" class="bill-weixin">
      <img :src="bill" alt="" class="bill-image" />
      <div class="weixin-share-button">
        <span>长按保存海报</span>
        <p class="p-text">或右上角...分享好友</p>
      </div>
      <div class="white-div" />
    </div>
    <div v-if="shareDown" class="share-down">
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/10/08/6bcb/9e3b1b125b15_w870_h1236_.gif"
        alt=""
        class="bg"
        @click="submitPost('gif')"
      />
      <div class="submit" @click="submitPost('button')">
        一键发布
      </div>
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/09/30/02bf/ac6e28e1f5ca_w105_h102_.png"
        alt=""
        class="close"
        @click="shareDown = false"
      />
    </div>
    <!-- 上传loading -->
    <Loading v-show="isShowH5UploadLoading" class="loading" />
  </div>
</template>

<script>
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import html2canvas from 'html2canvas';
import { doPoint, requestEvent } from '@/utils/index';
// eslint-disable-next-line import/no-extraneous-dependencies
import Loading from '@/components/Loading';
import auth from '@/services/auth';
// import Dom2Qiniu from '@/utils/dom2qiniu.js';
import {
  getQinxinDisseminateBillInfo,
  saveQinxinDisseminateBill,
  isLogin,
} from '@/services/index';
import { wxSdkSign } from '@/utils/wx';
import UploadImg from './components/UploadImg';

const wx = require('weixin-js-sdk');

export default {
  components: {
    UploadImg,
    Loading,
  },
  data() {
    return {
      isFromChunyu: cyDetect.isFromCYAll(),
      isFromWeixin: cyDetect.isFromWechat(),
      showText: '', // 展示文字
      inputText: '', // 输入文字
      data: {
        nickname: '',
        attend_num: 0,
        qr_code: '',
        tag_image_list: '',
        text_list: '',
      },
      tagImage: '', // 标签图片
      showEdit: false, // 展示编辑
      isShowH5UploadLoading: false, // loading
      imageSrc: [],
      bill: '', // 海报图
      showBill: false, // 展示海报
      billCreating: false, // 海报生成中
      uploadConfig: {
        // 上传配置
        validateOptions: {
          miniCount: 1,
          maxCount: 2, // 上传数量
          miniSize: '0',
          maxSize: '10240', // 文件大小
          typesCanBeSent: [
            'image/gif',
            'image/png',
            'image/jpeg',
            'image/bmp',
            'image/webp',
          ], // 文件类型
        },
      },
      shareDown: false, // 分享成功
    };
  },
  watch: {
    imageSrc(n) {
      console.log(n, 'n');
    },
  },
  mounted() {
    isLogin().then(res => {
      const { is_login } = res;
      if (!is_login) {
        requestEvent();
      } else {
        wxSdkSign();
        this.getData();
        // 监听hashchange，标识成功分享
        this.onHashChange();
        this.imageSrc = [window.sessionStorage.getItem('img')];
        if (this.imageSrc.length) {
          window.sessionStorage.removeItem('img');
        }
        this.doPagePoint('PageView', {
          activity_name: '青心计划海报传播活动',
          page_title: '分享我的治愈瞬间',
        });
      }
    });
  },
  methods: {
    /**
     * 小程序分享成功通过hash传递
     */
    onHashChange() {
      let hash;
      // 监听hash变化
      window.addEventListener(
        'popstate',
        () => {
          // 有hash值时返回上一个页面，并储存hash。
          // 因为返回了上一个页面，会立马进入else分支。
          // 将存好的hash渲染到页面
          if (window.location.hash) {
            hash = window.location.hash;
            console.log(hash, 'hash');
            if (hash === '#share') {
              this.shareDown = true;
            }
          }
        },
        false
      );
    },
    /**
     * 获取数据
     */
    getData() {
      getQinxinDisseminateBillInfo().then(resp => {
        console.log(resp, '海报数据');
        if (resp.error_code === 0) {
          this.data = resp;
          this.randomGetTagImg();
          this.randomGetText();
        } else {
          console.error('数据获取失败');
        }
      });
    },
    /**
     * 随机获取tag
     */
    randomGetTagImg() {
      if (this.data.tag_image_list) {
        const items = this.data.tag_image_list;
        this.tagImage = items[Math.floor(Math.random() * items.length)];
      }
    },
    /**
     * 随机获取文案
     */
    randomGetText() {
      if (this.data.text_list) {
        const items = this.data.text_list;
        this.showText = items[Math.floor(Math.random() * items.length)];
      }
    },
    /**
     * 点击编辑
     */
    onEditClick() {
      this.showEdit = true;
      this.inputText = this.showText;
    },
    /**
     * 确认文案
     */
    submitText() {
      this.showText = this.inputText;
      this.showEdit = false;
    },
    /**
     * 生成海报
     */
    getBill() {
      this.doPagePoint('AppClick', {
        activity_name: '青心计划海报传播活动',
        page_title: document.title,
        click_position: '生成海报',
      });
      this.billCreating = true;
      this.isShowH5UploadLoading = true;
      const toast = this.$createToast({
        time: 5000,
        txt: `海报生成中`,
        type: 'txt',
      });
      toast.show();
      const ap = this.$refs.credentialsShare;
      setTimeout(() => {
        html2canvas(ap, {
          allowTaint: true,
          useCORS: true,
          width: this.$refs.credentialsShare.scrollWidth,
          height: this.$refs.credentialsShare.clientHeight - 80,
        })
          .then(resp => {
            const base64Image = resp.toDataURL('image/jpeg');
            // 上传至七牛云获取图片url
            this.uploadQiNiu(base64Image).then(resp => {
              const { img_url } = resp;
              saveQinxinDisseminateBill({
                image: img_url,
              }).then(res => {
                console.log(res, 'res');
              });
              toast.hide();
              this.isShowH5UploadLoading = false;
              this.bill = img_url;
              this.billCreating = false;
              if (this.isFromChunyu) {
                const opt = {
                  img_base64: base64Image,
                  share_to: [
                    'weixin_haoyou',
                    'weixin_pengyouquan',
                    'qq',
                    'pic',
                  ],
                  userName: 'gh_681d3fd5683f', // 安卓
                  mini_id: 'gh_681d3fd5683f', // IOS
                  direct_share_to: 'pic',
                  path: `/pages/h5_webview/index?url=${encodeURIComponent(
                    window.location.href
                  )}`,
                };
                cyShare.app(opt);
                // 模拟分享成功
                setTimeout(() => {
                  this.shareDown = true;
                }, 500);
              } else {
                this.setWxMiniShare();
                this.showBill = true;
              }
            });
          })
          .catch(err => {
            console.log('海报生成失败', err);
          });
      }, 100);
    },
    async uploadQiNiu(image) {
      const res = await auth.getToken();
      const { token } = res;
      return new Promise((resolve, reject) => {
        this.uploadbase64ToQiniu(image, token)
          .then(resp => {
            console.log(resp, 'qiniudata');
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    uploadbase64ToQiniu(base64Str = '', token = '') {
      const base64 =
        base64Str.indexOf('base64,') !== -1
          ? base64Str.split('base64,')[1]
          : base64Str;

      const url = 'https://up-z0.qiniup.com/putb64/-1'; // 华北地区七牛仓库位置

      return new Promise((resolve, reject) => {
        // 发请求
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            const data = JSON.parse(xhr.response);
            if (data.success) resolve(data);
            else reject(data);
          }
        };
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        xhr.setRequestHeader('Authorization', `UpToken ${token}`);
        xhr.send(base64);
      });
    },
    /**
     * 生成海报
     *
     * @param tag 点击位置
     */
    submitPost(tag) {
      const click_position = tag === 'gif' ? '引导发布动图' : '一键发布';
      this.doPagePoint('AppClick', {
        activity_name: '青心计划海报传播活动',
        page_title: '分享我的治愈瞬间',
        click_position,
      });
      const url = `${window.location.origin}/v-m-community/send-invitation?qingxin=1`;
      if (this.isFromChunyu) {
        window.location.href = url;
      } else {
        wx.miniProgram.getEnv(wxres => {
          if (wxres.miniprogram) {
            // 小程序环境
            wx.miniProgram.redirectTo({
              url: `/pages/h5_webview/index?url=${encodeURIComponent(url)}`,
            });
          }
        });
      }
    },
    /**
     * 设置微信小程序分享
     */
    setWxMiniShare() {
      const { bill } = this;
      wx.miniProgram.getEnv(wxres => {
        if (wxres.miniprogram) {
          wx.miniProgram.postMessage({
            data: {
              img: bill, // 分享的图片展示
              title: '青心计划|分享你的治愈瞬间，度过那段难熬的日子', // 标题
              link: encodeURIComponent(
                `${window.location.origin}/v-m-general/qingxin-disseminate/`
              ), // 分享后点击卡片的跳转链接
              origin: 'qingxin-disseminate', // 来源
            },
          });
        }
      });
    },
    /**
     * 打点函数
     *
     * @param type type
     * @param data 打点数据
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.bill-wrapper {
  min-height: 100vh;
  background: #ffe9d3;
}
.qingxin-disseminate-bill {
  display: inline-block;
  width: 100vw;
  min-height: calc(100vh - 2.4rem);
  padding-bottom: 3.1rem;
  background: #ffe9d3;
  .bg {
    position: absolute;
    z-index: 0;
    width: 100vw;
  }
  .card-wrapper {
    position: relative;
    box-sizing: border-box;
    width: rem(335);
    margin: rem(55) auto 0 auto;
    padding: rem(15) rem(15) rem(30) rem(15);
    background: #fff;
    border-radius: rem(20);
    box-shadow: 0 3px 12px 0 #ffd3b6;
    .little-pi {
      position: absolute;
      top: -0.7rem;
      right: -0.29rem;
      width: rem(92);
      height: rem(102);
    }
    .img-wrapper {
      width: 100%;
      margin-bottom: rem(15);
      .img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: rem(15);
      }
    }
    .text-wrapper {
      margin-bottom: rem(15);
      .change-button {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        width: rem(267);
        height: rem(24);
        margin-bottom: rem(10);
        padding-left: rem(11);
        color: #f25e10;
        font-size: rem(14);
        border: 1px solid #ffae83;
        border-radius: rem(12);
      }
      .change-button-icon {
        width: rem(16);
        margin-left: rem(4);
      }
      .text {
        display: -webkit-box;
        margin-bottom: rem(14);
        overflow: hidden;
        color: #323232;
        font-weight: bold;
        font-size: rem(18);
        line-height: 1.4;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .tag-image {
        width: rem(104);
        height: rem(25);
        object-fit: contain;
      }
    }
    .split {
      margin-bottom: rem(20);
      border: 0.5px dashed #979797;
    }
    .bottom-info {
      display: flex;
      align-items: center;
      .qingxin-text {
        color: #323232;
        font-weight: bold;
        font-size: 16px;
        span {
          display: inline-block;
          line-height: rem(25);
        }
        .tip-wrapper {
          width: rem(172);
          height: rem(25);
          padding-left: rem(14);
          color: #fff;
          font-weight: bold;
          font-size: rem(14);
          line-height: rem(25);
          background: #ffa224;
          border-radius: rem(13);
          .tip-icon {
            width: rem(16);
            height: rem(13);
          }
        }
      }
      .qr-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: rem(108);
        height: rem(108);
        margin-left: rem(20);
        border: 1px solid #ffbc90;
        border-radius: rem(8);
        .qr {
          width: rem(98);
          height: rem(98);
        }
      }
    }
  }
  .bottom-img {
    display: block;
    width: rem(250);
    height: rem(24);
    margin: rem(30) auto 0 auto;
  }

  .edit-wrapper {
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    .text-area-wrapper {
      width: rem(345);
      height: rem(128);
      margin: 0 auto;
      padding: rem(20) rem(15);
      background: #fff;
      border-top-left-radius: rem(8);
      border-top-right-radius: rem(8);
      .text-area {
        height: rem(80);
        color: #323232;
        font-size: rem(16);
        border: none;
      }
    }
    .submit-button-wrapper {
      width: rem(345);
      height: rem(60);
      margin: 0 auto;
      padding: rem(8);
      background: #fff;
      border-bottom-right-radius: rem(8);
      border-bottom-left-radius: rem(8);
      box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
      .button {
        width: rem(165);
        height: rem(44);
        margin: 0 auto;
        color: #fff;
        font-weight: bold;
        font-size: rem(16);
        line-height: rem(44);
        text-align: center;
        background: #ff8400;
        border-radius: rem(22);
      }
    }
  }
  .special-btn {
    width: 100px;
    height: 100px;
  }
  .cube-textarea_active::after {
    border-color: #ffae83;
  }
}
.bottom-button {
  position: fixed;
  bottom: 0;
  z-index: 1;
  display: flex;
  width: 100%;
  height: rem(93);
  background: #fff;
  .upload-button {
    position: relative;
    width: rem(130);
    height: rem(60);
    color: #f80;
    font-weight: bold;
    font-size: 16px;
    line-height: rem(60);
    text-align: center;
  }
  .right {
    flex: 1;
    height: rem(60);
    color: #fff;
    font-weight: bold;
    font-size: rem(16);
    line-height: rem(60);
    text-align: center;
    background: #f80;
  }
}
.bill-weixin {
  position: fixed;
  top: 0;
  z-index: 300;
  height: 100vh;
  padding-bottom: rem(93);
  overflow: scroll;

  .bill-image {
    width: 100vw;
    min-height: calc(100vh - 2rem);
  }
  .weixin-share-button {
    position: fixed;
    bottom: 0.88rem;
    width: 100vw;
    height: rem(60);
    padding-top: rem(12);
    color: #fff;
    font-weight: bold;
    font-size: rem(16);
    text-align: center;
    background: #ff8400;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
    .p-text {
      line-height: 0;
    }
  }
  .white-div {
    position: fixed;
    bottom: 0;
    z-index: 300;
    width: 100vw;
    height: rem(33);
    background: #fff;
  }
}
.loading {
  position: absolute;
  top: 199px;
  left: 50%;
}
.share-down {
  position: fixed;
  top: 0;
  z-index: 300;
  width: 100vw;
  min-height: 100vh;
  padding: rem(106) rem(43) 0 rem(43);
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  .bg {
    width: rem(290);
  }
  .submit {
    position: absolute;
    top: rem(460);
    left: rem(62);
    width: rem(250);
    height: rem(44);
    color: #fff;
    font-size: rem(16);
    line-height: rem(44);
    text-align: center;
    background-image: linear-gradient(270deg, #f50 0%, #ff8400 100%);
    border-radius: rem(22);
  }
  .close {
    position: absolute;
    top: rem(540);
    left: rem(172);
    width: rem(37);
  }
}
</style>
